module.exports = __webpack_public_path__ + "img/arrow_back.33e7429d.svg";